export const DataTypesOfContact = [
    {
        phoneTypeText: 'COMERCIAL',
        phoneTypeId: 1
    },
    {
        phoneTypeText: 'RESIDENCIAL',
        phoneTypeId: 2
    },
    {
        phoneTypeText: 'CELULAR',
        phoneTypeId: 3
    },
    {
        phoneTypeText: 'WHATSAPP',
        phoneTypeId: 7
    },
];
